import { render, staticRenderFns } from "./CreatePrivateRateHead.vue?vue&type=template&id=77195551&scoped=true&"
import script from "./CreatePrivateRateHead.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CreatePrivateRateHead.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./CreatePrivateRateHead.vue?vue&type=style&index=0&id=77195551&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77195551",
  null
  
)

export default component.exports